import React from 'react';
import { List, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { MobileBottomSheet } from './mobile-bottom-sheet';

export function MobileActionSheet({ open, onClose, title = 'Actions', actions = [] }) {
  return (
    <MobileBottomSheet open={open} onClose={onClose} title={title}>
      <List disablePadding>
        {actions.map((action, index) => (
          <ListItemButton
            key={action.id ?? index}
            disabled={action.disabled}
            {...(action.href && { component: 'a', href: action.href, download: action.download })}
            onClick={() => {
              onClose();
              action.onClick?.();
            }}
            sx={{ borderRadius: 2, py: 1.5, minHeight: 52 }}
          >
            {action.icon && <ListItemIcon sx={{ minWidth: 40 }}>{action.icon}</ListItemIcon>}
            <ListItemText
              primary={action.label}
              primaryTypographyProps={{ fontWeight: 500 }}
            />
          </ListItemButton>
        ))}
      </List>
    </MobileBottomSheet>
  );
}
